export default [
  {
    key: 'holdDuration',
    label: 'label.holdDuration',
    type: 'single-selection',
    options: [
      { value: 5, name: 'five_minutes' },
      { value: 10, name: 'ten_minutes' },
      { value: 30, name: 'thirty_minutes' },
      { value: 60, name: 'one_hour' },
      { value: 120, name: 'two_hours' },
      { value: 300, name: 'five_hours' },
      { value: 1440, name: 'one_day' },
      { value: 'custom', name: 'customize' },
      { value: 'datetime', name: 'specificDatetime' }
    ],
    selectionKey: 'value',
    selectionLabel: 'name',
    placeholder: 'placeholder.selectHoldDuration',
    reduce: true,
    hint: 'label.holdDurationHint',
    rules: 'required',
    cols: 12,
  },
  {
    key: 'customHoldDuration',
    label: 'customize',
    placeholder: 'placeholder.enterHoldDuration',
    type: 'number',
    rules: 'required|min_value:1',
    cols: 12,
  },
  {
    key: 'holdUntilDatetime',
    label: 'specificDatetime',
    type: 'date-time',
    rules: 'required',
    placeholder: 'placeholder.selectSpecificDatetime',
    required: true,
    cols: 12,
  },
  {
    key: 'remark',
    label: 'label.remark',
    hint: 'label.remarkHoldHint',
    type: 'textarea',
    rules: 'min:2|max:1000',
    rows: '5',
    cols: 12,
  },
]
